import { render, staticRenderFns } from "./CategoryProduct.vue?vue&type=template&id=e5011722&scoped=true&"
import script from "./CategoryProduct.vue?vue&type=script&lang=js&"
export * from "./CategoryProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5011722",
  null
  
)

export default component.exports